import { render, staticRenderFns } from "./class-type-view.vue?vue&type=template&id=08854742&scoped=true"
import script from "./class-type-view.vue?vue&type=script&lang=js"
export * from "./class-type-view.vue?vue&type=script&lang=js"
import style0 from "./class-type-view.vue?vue&type=style&index=0&id=08854742&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08854742",
  null
  
)

export default component.exports